import React from 'react';
import { motion } from 'framer-motion';
const eventImages = [{
  id: 1,
  src: 'https://cdn.magicpatterns.com/uploads/xgAjMwPUAid8rRjnukXkkw/WhatsApp_Image_2026-05-08_at_11.38.38.jpg',
  alt: 'Evento - Mariela Carabajal en vivo - Domingo 10 de Mayo'
}];
const whatsappUrl = 'https://wa.me/5493417453398?text=Hola%2C+quiero+consultar+por+los+próximos+eventos+en+El+Matambrito+🍖';
export function Events() {
  return <section id="eventos" className="py-12 md:py-24 bg-matambrito-charcoal relative overflow-hidden" data-id="element-168">
      {/* Background ambient light */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-96 bg-matambrito-red-dark/10 blur-[100px] rounded-full pointer-events-none" data-id="element-169"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-170">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-171">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-matambrito-cream mb-4" data-id="element-172">
            Cada semana en El Matambrito se vive{' '}
            <span className="text-matambrito-gold" data-id="element-173">algo especial</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-matambrito-beige font-light" data-id="element-174">
            Cenas show, artistas en vivo, ferias y fechas que se convierten en
            recuerdos.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-0 sm:gap-6 max-w-5xl mx-auto -mx-4 sm:mx-auto" data-id="element-175">
          {eventImages.map((img, index) => <motion.div key={img.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="sm:rounded-2xl overflow-hidden sm:border border-matambrito-red-dark/30 hover:border-matambrito-red-fire transition-colors duration-300 sm:col-span-2 lg:col-span-3 sm:max-w-sm sm:mx-auto" data-id="element-176">
              <img src={img.src} alt={img.alt} className="w-full h-auto object-contain sm:h-[600px] sm:object-contain sm:bg-matambrito-charcoal" data-id="element-177" />
            </motion.div>)}
        </div>

        {/* Bottom CTAs */}
        <div className="mt-16 flex flex-col items-center" data-id="element-178">
          <p className="text-matambrito-beige mb-6 text-lg" data-id="element-179">
            ¿Querés saber qué pasa este fin de semana?
          </p>
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-180">
            <a href="https://instagram.com/elmatambritovgg" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-white/5 hover:bg-white/10 text-matambrito-cream px-8 py-3 rounded-md font-medium transition-colors text-center border border-white/10" data-id="element-181">
              Ver en @elmatambritovgg
            </a>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-matambrito-red-fire hover:bg-matambrito-red-dark text-white px-8 py-3 rounded-md font-medium transition-colors text-center" data-id="element-182">
              Consultar Próximos Shows
            </a>
          </div>
        </div>
      </div>
    </section>;
}